import styled from 'styled-components';
import {Button} from 'antd';
import Card from '../../../Card';
import InvoiceAttachmentPreview from '../../TransactionsPage/InvoiceAttachmentPreview';


const StyledInvoiceDocumentCard = styled(Card)`
  .ant-card-head {
    position: relative;
    z-index: 2;
  }
`;

const StyledInvoiceDocumentCardPreview = styled(InvoiceAttachmentPreview)`
  max-height: unset;
`;

const StyledInvoiceDocumentCardDownloadButton = styled(Button)`
  display: flex;
  align-items: center;
  padding: 0;
  
  svg {
    path {
      fill: ${props => props.theme.colors.neutral_10};
      transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    }
  }
  
  &.ant-btn-text:not(:disabled):not(.ant-btn-disabled) {
    &:hover {
      background-color: unset;
      color: ${props => props.theme.colors.neutral_8};
      
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_8};
        }
      }
    }
    
    &:active,
    &:focus {
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_8};
        }
      }
    }
  }
`;

export {
  StyledInvoiceDocumentCard,
  StyledInvoiceDocumentCardPreview,
  StyledInvoiceDocumentCardDownloadButton,
}
